<template>
  <div class="layout">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'layout'
}
</script>
<style lang="scss" scoped>
  .layout {
    display: flex;
    justify-content: space-between;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/index.vue